module.exports = __webpack_public_path__ + "img/pull.15d320b7.png";